module.exports = __webpack_public_path__ + "static/media/defi-pulse.5eb042fa.png";